var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotFoundBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1240,
    height: 869,
    viewBox: "0 0 1240 869",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_60_4)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1240,
    height: 869,
    rx: 40,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_60_4)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1222.71,
    cy: -25.293,
    r: 250,
    transform: "rotate(-59.8736 1222.71 -25.293)",
    fill: "#0017E7",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter1_f_60_4)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.9378,
    cy: 808.735,
    rx: 250,
    ry: 385.539,
    transform: "rotate(-59.8736 24.9378 808.735)",
    fill: "#0017E7",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter2_f_60_4)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 351.736,
    cy: 300.512,
    rx: 351.736,
    ry: 300.512,
    transform: "matrix(-0.986142 -0.165903 -0.165903 0.986142 982.435 729.708)",
    fill: "#E700C8",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter3_f_60_4)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 351.736,
    cy: 300.512,
    rx: 351.736,
    ry: 300.512,
    transform: "matrix(-0.359723 -0.933059 -0.933059 0.359723 1109.85 54.3808)",
    fill: "#E700C8",
    fillOpacity: 0.1
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_60_4",
    x: 772.666,
    y: -475.334,
    width: 900.082,
    height: 900.082,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100,
    result: "effect1_foregroundBlur_60_4"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_60_4",
    x: -531.446,
    y: 318.56,
    width: 1112.77,
    height: 980.35,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100,
    result: "effect1_foregroundBlur_60_4"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_60_4",
    x: 104.246,
    y: 534.606,
    width: 962.943,
    height: 866.191,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 65.5002,
    result: "effect1_foregroundBlur_60_4"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_60_4",
    x: 264.226,
    y: -642.338,
    width: 877.395,
    height: 953.259,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 65.5002,
    result: "effect1_foregroundBlur_60_4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_60_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1240,
    height: 869,
    rx: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFoundBg);
export default __webpack_public_path__ + "static/media/notFound_bg.4cea36bb7fdc80c84fbfe3eeb1df1094.svg";
export { ForwardRef as ReactComponent };